import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api, { formatPrice } from "@/lib/api";
import { Button } from "@/components/ui/button";
import ProductCard from "@/components/ProductCard";
import Reveal from "@/components/Reveal";
import { useCart } from "@/context/CartContext";
import { Check } from "lucide-react";

export default function Shop() {
  const { data: products = [] } = useQuery({ queryKey: ["products"], queryFn: async () => (await api.get("/products")).data });
  const { addItem, has } = useCart();
  const ebooks = products.filter((p) => !p.is_pack);
  const pack = products.find((p) => p.is_pack);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
      <Reveal>
        <p className="font-overline text-terracotta mb-3">Boutique</p>
        <h1 className="font-heading text-4xl sm:text-5xl text-ink tracking-tight">Nos eBooks</h1>
        <p className="mt-4 text-ink-muted max-w-2xl leading-relaxed">Des guides numériques au format PDF, accessibles immédiatement après l'achat, sur tous vos appareils.</p>
      </Reveal>

      {pack && (
        <Reveal className="mt-10">
          <div className="bg-ink text-sand rounded-xl p-8 grid md:grid-cols-[1fr_auto] gap-6 items-center" data-testid="shop-pack-banner">
            <div>
              <p className="font-overline text-terracotta-light mb-2">Meilleure offre</p>
              <h2 className="font-heading text-2xl sm:text-3xl">{pack.title}</h2>
              <p className="text-sand/70 mt-2 text-sm max-w-lg">{pack.short_description}</p>
              <ul className="mt-3 flex flex-wrap gap-x-5 gap-y-1 text-sm text-sand/80">
                {pack.pack_items?.map((c) => <li key={c.slug} className="flex items-center gap-1.5"><Check className="h-3.5 w-3.5 text-sage" />{c.title}</li>)}
              </ul>
            </div>
            <div className="flex flex-col items-start md:items-end gap-3">
              <div className="flex items-baseline gap-2">
                <span className="text-3xl font-semibold text-white">{formatPrice(pack.price)}</span>
                {pack.compare_price && <span className="text-sand/50 line-through">{formatPrice(pack.compare_price)}</span>}
              </div>
              <div className="flex gap-2">
                <Button asChild variant="outline" className="border-sand/30 text-sand hover:bg-white/10 bg-transparent rounded-md"><Link to="/pack">Découvrir</Link></Button>
                <Button onClick={() => addItem(pack)} disabled={has(pack.id)} className="bg-terracotta hover:bg-terracotta-dark text-white rounded-md" data-testid="shop-add-pack">{has(pack.id) ? "Ajouté" : "Acheter le pack"}</Button>
              </div>
            </div>
          </div>
        </Reveal>
      )}

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {ebooks.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>
    </div>
  );
}
